import React, { useMemo, useState } from 'react';
import RiddleHistoryModal from './RiddleHistoryModal';
import './RiddleHistoryToggle.css';

const RiddleHistoryToggle = ({ riddles }) => {
  const count = Array.isArray(riddles) ? riddles.length : 0;
  const hasAny = count > 0;
  const [isOpen, setIsOpen] = useState(false);

  const label = useMemo(() => {
    if (!hasAny) return 'No previous riddles';
    return `Show history (${count})`;
  }, [count, hasAny]);

  if (!hasAny) return null;

  return (
    <div className="riddle-history-toggle">
      <button
        type="button"
        className="riddle-history-toggle-button"
        onClick={() => setIsOpen(true)}
        aria-haspopup="dialog"
      >
        {label}
      </button>

      <RiddleHistoryModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        riddles={riddles}
      />
    </div>
  );
};

export default RiddleHistoryToggle;

